import { render, staticRenderFns } from "./App.vue?vue&type=template&id=30ea3142&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=30ea3142&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea3142",
  null
  
)

export default component.exports